import styled from 'styled-components';

export const LoadingDotsWrapper = styled.span`
  display: inline-block;
  min-width: ${props => props.size};
  color: ${props => props.color};
  font-family: monospace;
`; 